"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerService = exports.LoggerServiceSingleton = void 0;
const index_1 = require("../storage/index");
const logger_1 = require("./logger");
const logger_models_1 = require("./logger.models");
class LoggerServiceSingleton {
    constructor() {
        this._logPrefix = "DEFAULT+PREFIX";
        this._cookiePrefix = "DEFAULT+PREFIX";
        this._logLevel = logger_models_1.LogLevel.Debug;
        this._logEnabled = false;
    }
    static get Instance() {
        // console.log("LoggerService.GetInstance");
        if (this.instance === null || this.instance === undefined) {
            // console.log("LoggerService.GetInstance. NO INSTANCE, CREATING");
            this.instance = new LoggerServiceSingleton();
            this.instance._loggers = new Map();
        }
        else {
            // console.log("LoggerService.GetInstance. HAS INSTANCE");
        }
        return this.instance;
    }
    setLogPrefix(val, cookie_prefix) {
        // console.log('Logger.setEnabled == ', clsName, val);
        this._logPrefix = val;
        this._cookiePrefix = cookie_prefix;
        index_1.CookiesStorage.setPrefix(cookie_prefix);
    }
    createLogger(name, style) {
        //console.log('creating Logger', name);
        this._logLevel = logger_models_1.LogLevel.Trace;
        this._logEnabled = true;
        if (index_1.CookiesStorage.get("logLevel")) {
            //console.log("%%%% has loglevel cookie");
            this._logLevel = logger_models_1.LogLevels.FromString(index_1.CookiesStorage.get("logLevel"));
        }
        ;
        let logEnabled = index_1.CookiesStorage.get("logEnabled");
        if (typeof logEnabled === "string") {
            if (logEnabled.toLowerCase() === "true") {
                this._logEnabled = true;
            }
            else {
                this._logEnabled = false;
            }
        }
        else {
            this._logEnabled = logEnabled;
        }
        //console.log("LoggerService.createLogger", name, "logEnabled", this._logEnabled, "logLevel", this._logLevel, "style", style);
        let logger = new logger_1.Logger(name, this._logEnabled, this._logLevel, style);
        logger.setLogPrefix(this._logPrefix);
        this._loggers.set(name, logger);
        return logger;
    }
    setEnabled(val) {
        //console.log("LOGGER SERVICE.setEnabled", val);
        this._logEnabled = val;
        index_1.CookiesStorage.set("logEnabled", val.toString(), { useRootDomain: true, path: '/', secure: true });
        this._loggers.forEach((logger, key, map) => {
            // console.log('logger', logger, 'key', key);
            logger.setEnabled(val);
        });
    }
    setLevel(strLogLevel) {
        try {
            //console.log("LOGGER SERVICE.setLevel", strLogLevel);
            // see if passed in string is a valid LogLevel
            index_1.CookiesStorage.set("logLevel", strLogLevel, { useRootDomain: true, path: '/', secure: true });
            this._logLevel = logger_models_1.LogLevels.FromString(strLogLevel);
            // console.log('setLevel...FromString = ', strLogLevel, ' --  level=', logLevel);
            this._loggers.forEach((value, key, map) => {
                value.setLogLevel(logger_models_1.LogLevels.FromString(strLogLevel));
            });
        }
        catch (e) {
            console.error(e.message);
        }
        // console.log('LOGGER SERVICE.setLevel', level);
    }
}
exports.LoggerServiceSingleton = LoggerServiceSingleton;
//console.log("LoggerServiceSingleton.Instance");
exports.LoggerService = LoggerServiceSingleton.Instance;
